import { getAccountDetails } from "api";
import { useSwrImmutable } from "hooks/useSwr";

export const usePlayer = (id?: string) => {
  const [user] = useSwrImmutable(id ? [id, "user"] : null, getAccountDetails);
  return user;
};
